import { getTsCustomerPortalClient } from '@montugroup/circuit-shared/api/customer-portal.client';
import { Button, Stack, Typography } from '@montugroup/design-system';
import { useState } from 'react';
import { DeactivateAccountModal } from './DeactivateAccountModal';

const client = getTsCustomerPortalClient();

export function DeactivateAccount() {
  const { data } = client.deactivationEligibility.useQuery({ queryKey: client.deactivationEligibility.keys });
  const [showDeactiveAccountModal, setShowDeactiveAccountModal] = useState(false);
  const isUserEligibleToDeactivateAccount = data?.body.isEligible;

  return (
    <Stack gap={6} alignItems={'flex-start'}>
      <Typography variant="subtitle1" component="h2" sx={(theme) => ({ color: theme.palette.primary.main })}>
        Deactivate Account
      </Typography>
      <Button
        disabled={!isUserEligibleToDeactivateAccount}
        variant={'contained'}
        color="error"
        size="large"
        sx={{
          width: {
            xs: '100%',
            md: 'auto',
          },
        }}
        onClick={() => setShowDeactiveAccountModal(true)}
      >
        Deactivate account
      </Button>
      {!isUserEligibleToDeactivateAccount && (
        <Typography variant="caption" color="textSecondary">
          You cannot deactivate your account while you have an active order.
        </Typography>
      )}
      <DeactivateAccountModal open={showDeactiveAccountModal} onClose={() => setShowDeactiveAccountModal(false)} />
    </Stack>
  );
}
